// extracted by mini-css-extract-plugin
export default {"header":"UH","light":"VH","dark":"WH","headertitle":"XH","fname":"YH","headerContent":"ZH","right":"aI","descriptionwrapper":"bI","appear":"cI","second":"eI","third":"fI","forth":"gI"};
    if(module.hot) {
      // 1713996749535
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  